import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, X, MessageCircle } from 'lucide-react';

const PHONE = '+40738562505';
const PHONE_DISPLAY = '+40 738 562 505';
const WA_URL = `https://wa.me/40738562505?text=${encodeURIComponent('Bună ziua! Aș dori o consultanță gratuită la domiciliu.')}`;

export default function PromoBanner({ visible, onClose, measureRef }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
          className="fixed top-0 left-0 right-0 z-[60] overflow-hidden"
          data-testid="promo-banner"
        >
          <div ref={measureRef} className="bg-[#A67B5B] text-white">
            <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 sm:py-2.5 flex items-center gap-2">

              {/* Center content */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 flex-1 text-center">
                <span className="text-xs sm:text-sm font-medium leading-tight">
                  🏠 Consultanță gratuită la domiciliu
                </span>
                <div className="flex items-center gap-2">
                  <a
                    href={`tel:${PHONE}`}
                    className="inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-0.5 sm:py-1 bg-white/20 hover:bg-white/30 rounded-full text-xs font-semibold transition-colors whitespace-nowrap"
                  >
                    <Phone size={11} />
                    {PHONE_DISPLAY}
                  </a>
                  <a
                    href={WA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-0.5 sm:py-1 bg-[#25D366] hover:bg-[#1da851] rounded-full text-xs font-semibold transition-colors whitespace-nowrap"
                  >
                    <MessageCircle size={11} />
                    WhatsApp
                  </a>
                </div>
              </div>

              {/* Close button */}
              <button
                onClick={onClose}
                aria-label="Închide banner"
                className="w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors flex-shrink-0"
              >
                <X size={14} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

